<template>
    <b-container>                                                                                    
        <!--title-->
        <h1 class="title"><strong>لیست محصولات</strong></h1>
        <!--productList-->
        <div class="productList parentLoading">
            <Loading :class="{loading1:true?loading1:false}"/>        
            <b-row v-if="fullProducts">
                <b-col class="col-4" v-for="(product,index) in products" :key="index"> 
                    <app-product  :product="product"></app-product>                                                         
                </b-col>                                                                  
            </b-row> 
            <span class="notFound" v-if="emptyProducts">{{notFound}}</span>
        </div>
    </b-container>
</template>
<script>
import Product from '../products/Product'
import axios from 'axios'
import Loading from '../Loading'

export default { 
    data(){
      return{       
        id:this.$route.params.id,              
        notFound:'هیچ کالایی در این دسته وجود ندارد' , 
        products:null,
        fullProducts:false,
        emptyProducts:false,
        loading1:false                   
      }
    }, 
    components: {   
        appProduct:Product,
        Loading  
    },
    watch:{
        '$route'(to,from){
            this.id = to.params.id
        }                  
    },   
    async created(){
        try{
            if(this.products == []){
                this.loading1 = true            
            } 
            await axios.get('/product/GetProductsByCategoriesId?id='+ this.id)
                .then((res)=>{               
                    this.products = res.data.ProductsLocalized   
                    if(this.products.length) return  this.fullProducts=true
                    else  this.emptyProducts=true
                    this.loading1 = false                                                           
                })
                .catch((err)=>{
                    console.log(err)
                })
        }
         catch (e) {console.log(e)}  
            
    },  
}
</script>
<style scoped>
.loading1{
  display: block;
}
.categoryPro {
    width: 100%;
    margin-bottom: 35px;
}
.notFound{
    background: #eee;
    padding: 15px 20px;
    border-radius: 25px;
    font-size: 14pt;
    color: #8e8d8d;
    margin: auto;
    display: block;
    text-align: center;
}
@media all and (max-width:576px) {
    .productList .row{margin: 0 -5px;}
    .productList .col-4{padding: 0 5px;}
    .notFound {
    padding: 10px 15px;
    font-size: 9pt;
}
}
</style>


// WEBPACK FOOTER //
// src/components/products/Products.vue